import store from 'redux/store'

import { reportError } from 'utils/error'
import client from 'api/client'
import { getLocation } from 'hooks/useHistory'

const UTM = 'utm'
const UTM_ALMANAC = 'utm_almanac'
const CAMPAIGN_STORAGE_KEY = 'almanacCampaign'

export const trackCampaign = () => {
  const { auth } = store.getState()
  const { pathname, search } = getLocation()
  const params = new URLSearchParams(search)
  const utm = (k: string) => k.startsWith(UTM)

  if ([...params.keys()].some(utm)) {
    const urlPathnameWithParams = pathname + search
    client.trackCampaignEvent(urlPathnameWithParams)

    if (!auth && params.has(UTM_ALMANAC)) {
      setCampaignUrl(urlPathnameWithParams)
    }
  }
}

export const setCampaignUrl = (url: string) => {
  try {
    const campaignUrl = localStorage.getItem(CAMPAIGN_STORAGE_KEY)
    if (!campaignUrl) localStorage.setItem(CAMPAIGN_STORAGE_KEY, url)
  } catch (e) {
    reportError(e, { severity: 'info', metaData: { message: 'setCampaignUrl localStorage error' } })
  }
}

export const getCampaignUrl = () => {
  try {
    const campaignUrl = localStorage.getItem(CAMPAIGN_STORAGE_KEY)
    if (campaignUrl) return campaignUrl
  } catch (e) {
    reportError(e, { severity: 'info', metaData: { message: 'getCampaignUrl localStorage error' } })
  }
}

export const unsetCampaignUrl = () => {
  try {
    localStorage.removeItem(CAMPAIGN_STORAGE_KEY)
  } catch (e) {
    reportError(e, { severity: 'info', metaData: { message: 'unsetCampaignUrl localStorage error' } })
  }
}
